export default class WitnessContractModel {
    nomeAssociado: string;
    cpfAssociado: string;
    cnpjAssociado: string;
    num_contrato: string;
    status: string;
    plano: string;
    valor_plano: string;
    dataFinal: string;
    userCancel: string;
  
    constructor({
      nomeAssociado,
      cpfAssociado,
      cnpjAssociado,
      num_contrato,
      status,
      plano,
      valor_plano,
      dataFinal,
      userCancel,
    }: {
      nomeAssociado: string;
      cpfAssociado: string;
      cnpjAssociado: string;
      num_contrato: string;
      status: string;
      plano: string;
      valor_plano: string;
      dataFinal: string;
      userCancel: string;
    }) {
      this.nomeAssociado = nomeAssociado;
      this.cnpjAssociado = cnpjAssociado;
      this.cpfAssociado = cpfAssociado;
      this.num_contrato = num_contrato;
      this.status = status;
      this.plano = plano;
      this.valor_plano = valor_plano;
      this.dataFinal = dataFinal;
      this.userCancel = userCancel;
    }
  
    static fromApiResponse(apiData: any): WitnessContractModel {
      return new WitnessContractModel({
        nomeAssociado: apiData.nome_associado,
        cnpjAssociado: apiData.cnpjAssociado,
        cpfAssociado: apiData.cpf_associado,
        num_contrato: apiData.num_contrato,
        status: apiData.status,
        plano: apiData.plano,
        valor_plano: apiData.valor_plano,
        dataFinal: apiData.dt_cancelamento,
        userCancel: apiData.usr_nome_cancel,
      });
    }
  }
  